export default "__VITE_ASSET__V$yuDr0O__"